export enum EducationalResourceTypeEnum {
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  LINK = "LINK",
}

export enum EducationalResourceStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
